// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Simple Login Page Styles - White & Blue Theme */
.login-page {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f3f4f6;
    padding: 20px;
  }
  
  .login-card {
    width: 100%;
    max-width: 400px;
    background: #ffffff;
    border-radius: 12px;
    padding: 40px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  
  .login-header {
    text-align: center;
    margin-bottom: 32px;
  }
  
  .login-header h1 {
    color: #0A3760;
    font-size: 28px;
    margin: 0 0 4px 0;
    font-weight: 700;
  }
  
  .login-header p {
    color: #1B5D9B;
    font-size: 14px;
    margin: 0;
    font-weight: 500;
  }
  
  .login-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
  
  .login-error {
    background: #fef2f2;
    border: 1px solid #fecaca;
    color: #dc2626;
    padding: 12px;
    border-radius: 8px;
    font-size: 14px;
    text-align: center;
  }
  
  .login-field {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .login-field label {
    color: #374151;
    font-size: 14px;
    font-weight: 500;
  }
  
  .login-field input {
    width: 100%;
    padding: 12px 16px;
    background: #f9fafb;
    border: 1px solid #d1d5db;
    border-radius: 8px;
    color: #111827;
    font-size: 14px;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    box-sizing: border-box;
  }
  
  .login-field input:focus {
    border-color: #0A3760;
    box-shadow: 0 0 0 3px rgba(10, 55, 96, 0.15);
  }
  
  .login-field input::placeholder {
    color: #9ca3af;
  }
  
  .password-wrapper {
    position: relative;
    display: flex;
    align-items: center;
  }
  
  .password-wrapper input {
    padding-right: 60px;
  }
  
  .toggle-password {
    position: absolute;
    right: 12px;
    background: none;
    border: none;
    color: #6b7280;
    font-size: 12px;
    cursor: pointer;
    padding: 4px 8px;
  }
  
  .toggle-password:hover {
    color: #0A3760;
  }
  
  .login-button {
    width: 100%;
    padding: 14px;
    background: #0A3760;
    border: none;
    border-radius: 8px;
    color: white;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s;
    margin-top: 8px;
  }
  
  .login-button:hover:not(:disabled) {
    background: #1B5D9B;
  }
  
  .login-button:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }`, "",{"version":3,"sources":["webpack://./src/pages/Login.css"],"names":[],"mappings":"AAAA,kDAAkD;AAClD;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,aAAa;IACb,8CAA8C;IAC9C,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB","sourcesContent":["/* Simple Login Page Styles - White & Blue Theme */\n.login-page {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #f3f4f6;\n    padding: 20px;\n  }\n  \n  .login-card {\n    width: 100%;\n    max-width: 400px;\n    background: #ffffff;\n    border-radius: 12px;\n    padding: 40px;\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  }\n  \n  .login-header {\n    text-align: center;\n    margin-bottom: 32px;\n  }\n  \n  .login-header h1 {\n    color: #0A3760;\n    font-size: 28px;\n    margin: 0 0 4px 0;\n    font-weight: 700;\n  }\n  \n  .login-header p {\n    color: #1B5D9B;\n    font-size: 14px;\n    margin: 0;\n    font-weight: 500;\n  }\n  \n  .login-form {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n  \n  .login-error {\n    background: #fef2f2;\n    border: 1px solid #fecaca;\n    color: #dc2626;\n    padding: 12px;\n    border-radius: 8px;\n    font-size: 14px;\n    text-align: center;\n  }\n  \n  .login-field {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .login-field label {\n    color: #374151;\n    font-size: 14px;\n    font-weight: 500;\n  }\n  \n  .login-field input {\n    width: 100%;\n    padding: 12px 16px;\n    background: #f9fafb;\n    border: 1px solid #d1d5db;\n    border-radius: 8px;\n    color: #111827;\n    font-size: 14px;\n    outline: none;\n    transition: border-color 0.2s, box-shadow 0.2s;\n    box-sizing: border-box;\n  }\n  \n  .login-field input:focus {\n    border-color: #0A3760;\n    box-shadow: 0 0 0 3px rgba(10, 55, 96, 0.15);\n  }\n  \n  .login-field input::placeholder {\n    color: #9ca3af;\n  }\n  \n  .password-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n  }\n  \n  .password-wrapper input {\n    padding-right: 60px;\n  }\n  \n  .toggle-password {\n    position: absolute;\n    right: 12px;\n    background: none;\n    border: none;\n    color: #6b7280;\n    font-size: 12px;\n    cursor: pointer;\n    padding: 4px 8px;\n  }\n  \n  .toggle-password:hover {\n    color: #0A3760;\n  }\n  \n  .login-button {\n    width: 100%;\n    padding: 14px;\n    background: #0A3760;\n    border: none;\n    border-radius: 8px;\n    color: white;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n    margin-top: 8px;\n  }\n  \n  .login-button:hover:not(:disabled) {\n    background: #1B5D9B;\n  }\n  \n  .login-button:disabled {\n    opacity: 0.7;\n    cursor: not-allowed;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
